import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "currentColor",
	height: "1em",
	viewBox: "0 0 9 15",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M4.5 15L9 9.42857H5.41667L5.41667 0L3.58333 0L3.58333 9.42857H0L4.5 15Z" }));
const ForwardRef = forwardRef(SvgArrowDown);
export default ForwardRef;
